import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const regions = ['All regions', 'North America', 'Latin America', 'Europe', 'India Middle East and Africa', 'Asia Pacific'];

const NewsSection = () => {
  const [selectedRegion, setSelectedRegion] = useState('All regions');
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, [selectedRegion]);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const url = selectedRegion === 'All regions' 
        ? `${API}/news`
        : `${API}/news?region=${encodeURIComponent(selectedRegion)}`;
      
      const response = await axios.get(url);
      if (response.data.success) {
        setNews(response.data.news);
      }
    } catch (error) {
      console.error('Error fetching news:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <h2 className="text-3xl lg:text-4xl font-bold text-[#0A1F3B] mb-8">
          Latest news
        </h2>
        <p className="text-gray-600 mb-8 max-w-3xl">
          Press releases, case studies and expert opinion from Supreme Global Freight, an integrated logistics company.
        </p>

        {/* Region Filter */}
        <div className="flex flex-wrap gap-3 mb-12">
          {regions.map((region) => (
            <Button
              key={region}
              variant={selectedRegion === region ? 'default' : 'outline'}
              onClick={() => setSelectedRegion(region)}
              className={selectedRegion === region ? 'bg-[#0A1F3B] hover:bg-[#0A1F3B]/90' : ''}
            >
              {region}
            </Button>
          ))}
        </div>

        {/* Loading State */}
        {loading ? (
          <div className="flex justify-center items-center py-20">
            <Loader2 className="w-8 h-8 animate-spin text-[#00ACC1]" />
          </div>
        ) : (
          <>
            {/* News Grid */}
            <div className="grid md:grid-cols-3 gap-8 mb-8">
              {news.map((item) => (
                <Card 
                  key={item.id} 
                  className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
                >
                  <CardContent className="p-6">
                    <div className="text-sm text-[#00ACC1] font-semibold mb-3">
                      {item.region}
                    </div>
                    <h3 className="text-xl font-semibold text-[#0A1F3B] mb-3 group-hover:text-[#00ACC1] transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 mb-4">
                      {item.excerpt}
                    </p>
                    <div className="text-sm text-gray-500">
                      {new Date(item.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>

            {news.length === 0 && (
              <div className="text-center py-12">
                <p className="text-gray-500">No news found for this region.</p>
              </div>
            )}

            <div className="text-center">
              <Button 
                variant="outline" 
                className="border-[#0A1F3B] text-[#0A1F3B] hover:bg-[#0A1F3B] hover:text-white px-8 py-6"
              >
                See all news
              </Button>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default NewsSection;